/*
 * Copyright (C) 2026 - present Fundacion Portas
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 */

import type {ThemeOrOverride} from '@instructure/emotion/types/EmotionTypes'

export const PORTAS_FONT_FAMILY = '"Montserrat", Arial, sans-serif'

export function getPortasTypography(useDyslexicFont = false) {
  return {
    fontFamily: useDyslexicFont ? `OpenDyslexic, ${PORTAS_FONT_FAMILY}` : PORTAS_FONT_FAMILY,
  }
}

export function withPortasTypography(
  theme: ThemeOrOverride,
  useDyslexicFont = false,
): ThemeOrOverride {
  if (typeof theme === 'function') return theme

  const typography = 'typography' in theme ? theme.typography : undefined

  return {
    ...theme,
    typography: {
      ...typography,
      ...getPortasTypography(useDyslexicFont),
    },
  }
}
